/**
 * va-logo-original-2026.js · On garde le fichier du client TEL QUEL.
 * ==================================================================
 *
 * DEMANDE DE SAMUEL (22 sept. 2026) : « Ne vectorise jamais les fichiers des
 * clients. Si le client met un JPEG, on reçoit un JPEG. »
 *
 * LE DÉFAUT. L'application (module compilé va-WBXOIXIN.js) lit le fichier du
 * client, le RÉDUIT à 900 px de côté, le détoure, le vectorise, puis jette
 * l'original. C'est cette version réduite (ou son tracé) qui partait au relais
 * et finissait sur la fiche client : pixelisée, inimprimable.
 *
 * CE QUE FAIT CE FICHIER, SANS TOUCHER AU CODE COMPILÉ :
 *   1. Il écoute, en phase de capture, les dépôts de fichier (champ fichier et
 *      glisser-déposer) et range le fichier ORIGINAL dans IndexedDB. Il le lie
 *      à l'image précise que l'application produit juste après (empreinte),
 *      jamais au nom du fichier. IndexedDB, parce qu'un original de 3 Mo ne
 *      tient pas dans localStorage.
 *   2. Il enveloppe fetch() : quand un envoi de logos part vers le relais
 *      (…/api/client), il remplace, pour chaque logo dont on a l'original, la
 *      version réduite par l'ORIGINAL, octet pour octet, même format.
 *   3. Si l'original dépasse ce que le relais accepte (~2,8 Mo), il envoie la
 *      meilleure version possible : l'image entière jusqu'à 4000 px, jamais
 *      les 900 px de l'application.
 *
 * NE CASSE JAMAIS L'ENVOI. Toute erreur ici laisse partir la requête d'origine,
 * inchangée. L'aperçu à l'écran (maquettes) n'est pas touché.
 */
(function () {
  "use strict";
  if (window.__vaLogoOriginal) return;

  var BASE = "va-originaux", STORE = "logos";
  var MAX_BRUT = 2.8 * 1024 * 1024;           // relais : 4 Mo de JSON, base64 +33 %
  var TYPES = /^(image\/(png|jpe?g|webp|svg\+xml|gif)|application\/pdf)$/i;

  function ouvrir() {
    return new Promise(function (ok, ko) {
      if (!window.indexedDB) return ko(new Error("indexeddb"));
      var r = indexedDB.open(BASE, 1);
      r.onupgradeneeded = function () { r.result.createObjectStore(STORE); };
      r.onsuccess = function () { ok(r.result); };
      r.onerror = function () { ko(r.error); };
    });
  }
  function ecrire(cle, val) {
    return ouvrir().then(function (db) {
      return new Promise(function (ok, ko) {
        var t = db.transaction(STORE, "readwrite");
        t.objectStore(STORE).put(val, cle);
        t.oncomplete = function () { ok(); };
        t.onerror = function () { ko(t.error); };
      });
    });
  }
  function lire(cle) {
    return ouvrir().then(function (db) {
      return new Promise(function (ok) {
        var r = db.transaction(STORE, "readonly").objectStore(STORE).get(cle);
        r.onsuccess = function () { ok(r.result || null); };
        r.onerror = function () { ok(null); };
      });
    }).catch(function () { return null; });
  }

  /* 1 · ON GARDE L'ORIGINAL AU MOMENT DU DÉPÔT, ET ON LE LIE EXACTEMENT
     Le lien ne se fait PAS par nom de fichier : deux clients d'un vendeur
     peuvent tous deux envoyer « logo.png ». Juste après un dépôt, on regarde
     quelle NOUVELLE image l'application écrit dans localStorage (va_logo,
     va_logos) et on lie l'empreinte de CETTE image à l'original. Sans lien
     exact, on ne remplace rien. */
  function empreinte(txt) {             // FNV-1a 32 bits, sur l'adresse de données
    var h = 0x811c9dc5, s = String(txt || "");
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193); }
    return ("0000000" + (h >>> 0).toString(16)).slice(-8) + ":" + s.length;
  }
  function imagesDeLApp() {
    var out = [];
    try { var a = localStorage.getItem("va_logo"); if (a) out.push(a); } catch (e) {}
    try {
      var l = JSON.parse(localStorage.getItem("va_logos") || "[]");
      if (Array.isArray(l)) l.forEach(function (x) { if (x && x.data) out.push(String(x.data)); });
    } catch (e) {}
    return out;
  }
  function garder(fichier) {
    try {
      if (!fichier || !fichier.name || !TYPES.test(fichier.type || "")) return;
      var cle = "orig:" + Date.now() + ":" + fichier.name;
      var val = { blob: fichier, nom: fichier.name, type: fichier.type, taille: fichier.size, quand: Date.now() };
      ecrire(cle, val).catch(function () {});
      var avant = {};
      imagesDeLApp().forEach(function (d) { avant[empreinte(d)] = 1; });
      var essais = 0, t = setInterval(function () {
        essais++;
        var nouvelles = imagesDeLApp().filter(function (d) { return !avant[empreinte(d)]; });
        if (nouvelles.length || essais > 60) clearInterval(t);   // 30 s max
        nouvelles.forEach(function (d) { ecrire("lien:" + empreinte(d), cle).catch(function () {}); });
      }, 500);
    } catch (e) {}
  }
  function depuisListe(liste) {
    if (!liste || liste.length !== 1) return;     // un seul fichier = un lien sans ambiguïté
    garder(liste[0]);
  }
  window.addEventListener("change", function (ev) {
    var el = ev.target;
    if (el && el.tagName === "INPUT" && el.type === "file") depuisListe(el.files);
  }, true);
  window.addEventListener("drop", function (ev) {
    try { depuisListe(ev.dataTransfer && ev.dataTransfer.files); } catch (e) {}
  }, true);

  /* 2 · L'ORIGINAL EN ADRESSE DE DONNÉES, OU LA MEILLEURE VERSION QUI PASSE */
  function enDonnees(blob) {
    return new Promise(function (ok, ko) {
      var f = new FileReader();
      f.onload = function () { ok(String(f.result)); };
      f.onerror = function () { ko(f.error); };
      f.readAsDataURL(blob);
    });
  }
  function grandeVersion(blob) {
    /* Trop lourd pour le relais : on redessine l'image ENTIÈRE, la plus grande
       possible, en descendant par paliers jusqu'à ce qu'elle passe. PNG
       d'abord (garde la transparence), puis JPEG. Jamais sous 1800 px : en
       dessous, on n'envoie rien de plus (l'envoi d'origine part tel quel). */
    return new Promise(function (ok, ko) {
      var url = URL.createObjectURL(blob), img = new Image();
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          var paliers = [4000, 3200, 2600, 2200, 1800];
          for (var p = 0; p < paliers.length; p++) {
            var k = Math.min(1, paliers[p] / Math.max(w, h));
            var cv = document.createElement("canvas");
            cv.width = Math.round(w * k); cv.height = Math.round(h * k);
            cv.getContext("2d").drawImage(img, 0, 0, cv.width, cv.height);
            var essais = [cv.toDataURL("image/png"), cv.toDataURL("image/jpeg", 0.95), cv.toDataURL("image/jpeg", 0.88)];
            for (var e = 0; e < essais.length; e++) if (essais[e].length * 0.75 <= MAX_BRUT) return ok(essais[e]);
          }
          ok(null);
        } catch (e) { ko(e); } finally { URL.revokeObjectURL(url); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); ko(new Error("illisible")); };
      img.src = url;
    });
  }
  function versionAEnvoyer(orig) {
    if (orig.taille <= MAX_BRUT) return enDonnees(orig.blob).then(function (d) { return { data: d, fidele: true }; });
    if (/pdf|svg/i.test(orig.type)) return Promise.resolve(null); // rien de mieux à proposer
    return grandeVersion(orig.blob).then(function (d) { return d ? { data: d, fidele: false } : null; });
  }

  /* 3 · ON REMPLACE, DANS L'ENVOI AU RELAIS, LA VERSION RÉDUITE PAR L'ORIGINAL */
  function estEnvoiLogos(url, init) {
    try {
      if (!init || String(init.method || "GET").toUpperCase() !== "POST") return false;
      if (typeof init.body !== "string" || init.body.indexOf('"logos"') < 0) return false;
      var u = new URL(String(url), location.href);
      return /\/api\/client\/?$/.test(u.pathname) && !/[?&](espace|commande|coffre|classement|equipe|couts)=/.test(u.search);
    } catch (e) { return false; }
  }
  function transformer(corps) {
    var b = JSON.parse(corps);
    if (!b || !Array.isArray(b.logos) || !b.logos.length) return Promise.resolve(corps);
    return Promise.all(b.logos.map(function (lg, i) {
      if (!lg || !lg.data) return lg;
      return lire("lien:" + empreinte(lg.data)).then(function (cle) {
        return cle ? lire(cle) : null;
      }).then(function (orig) {
        if (!orig || !orig.blob) return lg;
        return versionAEnvoyer(orig).then(function (v) {
          if (!v) return lg;
          var n = Object.assign({}, lg, { data: v.data, original: v.fidele, typeOriginal: orig.type });
          if (orig.nom) n.name = orig.nom;
          return n;
        }).catch(function () { return lg; });
      });
    })).then(function (logos) {
      b.logos = logos;
      return JSON.stringify(b);
    });
  }

  var fetchOrig = window.fetch;
  if (typeof fetchOrig === "function") {
    window.fetch = function (url, init) {
      if (!estEnvoiLogos(url, init)) return fetchOrig.apply(this, arguments);
      var self = this, args = arguments;
      return transformer(init.body).then(function (corps) {
        if (corps === init.body) return fetchOrig.apply(self, args);
        var n = Object.assign({}, init, { body: corps });
        if (corps.length > 60000) delete n.keepalive;   // keepalive plafonne à 64 ko
        return fetchOrig.call(self, url, n);
      }, function () { return fetchOrig.apply(self, args); });
    };
  }

  window.__vaLogoOriginal = { version: 2, lire: lire, transformer: transformer, estEnvoiLogos: estEnvoiLogos, empreinte: empreinte, garder: garder };
})();
